<template>
    <div>
        <CommonTable :data="formattedData" :columns="columns" max-height="37vh" />

    </div>
</template>

<script>
import CommonTable from "../common/CommonTable.vue";

export default {
    name: "BillDailyUsageTable",
    components: {
        CommonTable,
    },
    props: {
        data: {
            type: Array,
            default: () => [],
            required: true,
        },
        selectedPeriod: {
            type: String,
            default: "monthly",
        },
    },
    computed: {
        // 오늘 날짜 (YYYYMMDD 또는 YYYYMM 형식)
        todayDateString() {
            const today = new Date();
            const year = today.getFullYear();
            const month = String(today.getMonth() + 1).padStart(2, "0");

            // 연간 조회(월별 데이터)인 경우 YYYYMM 형식
            if (this.selectedPeriod === "yearly") {
                return `${year}${month}`;
            }

            // 월간 조회(일별 데이터)인 경우 YYYYMMDD 형식
            const day = String(today.getDate()).padStart(2, "0");
            return `${year}${month}${day}`;
        },
        formattedData() {
            return this.data.map((item) => {
                const itemDate = item.regDt;
                const isFuture = itemDate > this.todayDateString;
                const isToday = itemDate === this.todayDateString;

                let displayUsage, displayCost, isPredicted;

                // 미래 날짜: 예측 데이터만 표시
                if (isFuture) {
                    displayUsage = item.predUsage || 0;
                    displayCost = item.predCost || 0;
                    isPredicted = true;
                }
                // 오늘 또는 과거: 실제 데이터 표시
                else {
                    displayUsage = item.usage || 0;
                    displayCost = item.cost || 0;
                    isPredicted = false;
                }

                return {
                    ...item,
                    formattedDate: this.formatDate(item.regDt),
                    displayUsage: displayUsage,
                    displayCost: displayCost,
                    isPredicted: isPredicted,
                    isFuture: isFuture,
                    isToday: isToday,
                };
            });
        },
        columns() {
            return [
                {
                    key: "formattedDate",
                    label: "조회 날짜",
                    align: "left",
                    cellClass: "date-cell",
                },
                {
                    key: "displayUsage",
                    label: "사용량 (kWh)",
                    align: "right",
                    type: "number",
                    cellClass: (row) => row.isPredicted ? "predicted-cell" : "",
                },
                {
                    key: "displayCost",
                    label: "사용 요금(원)",
                    align: "right",
                    type: "number",
                    cellClass: (row) => row.isPredicted ? "cost-cell predicted-cell" : "cost-cell",
                },
            ];
        },
    },
    methods: {
        formatDate(date) {
            if (this.selectedPeriod === "monthly") {
                return date.substring(0, 4) + "년 " + date.substring(4, 6) + "월" + " " + date.substring(6, 8) + "일";
            } else if (this.selectedPeriod === "yearly") {
                return date.substring(0, 4) + "년" + " " + date.substring(4, 6) + "월";
            } else {
                return date;
            }
        },
    },
};
</script>

<style scoped>
/* 날짜 셀 스타일 */
:deep(.date-cell) {
    color: #64748b;
    font-weight: 500;
}

/* 비용 셀 스타일 */
:deep(.cost-cell) {
    color: #1e40af;
    font-weight: 600;
}

/* 예측 데이터 셀 스타일 */
:deep(.predicted-cell) {
    color: #94a3b8 !important;
    font-style: italic;
    opacity: 0.8;
}
</style>
